import React from 'react';

interface Props {}

const AmbassadorQualifyList: React.FC<Props> = () => (
  <ul>
    <li>Make at least 3 sales and / or purchases on SidelineSwap</li>
    <li>Maintain seller feedback over 90% (if you’ve made a sale).</li>
    <li>
      To remain an ambassador, you need to refer at least 2 new users every 30
      days.
    </li>
  </ul>
);

export default AmbassadorQualifyList;
